// Controle local (por navegador) da última mensagem lida de cada chat de rota.
// Usado para exibir o indicador de "nova mensagem" sem controle de leitura no servidor.

const STORAGE_KEY = 'route_chat_last_read'

function readMap() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}
  } catch (error) {
    return {}
  }
}

export function getLastReadMessageId(fleetId) {
  return Number(readMap()[String(fleetId)]) || 0
}

export function registerReadMessageId(fleetId, messageId) {
  const id = Number(messageId) || 0
  if (!fleetId || !id) return

  const map = readMap()
  const key = String(fleetId)
  if (id <= (Number(map[key]) || 0)) return

  map[key] = id
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map))
}
